export const ANIMATIONS = [
  'fadeIn',
  'fadeInDown',
  'fadeInLeft',
  'fadeInRight',
  'fadeInUp',
  /* 'flipInX',
  'slideInUp',
  'slideInDown',
  'slideInLeft',
  'slideInRight',
  'zoomIn',
  'zoomInDown',
  'zoomInLeft',
  'zoomInRight',
  'zoomInUp', */
];

class ScrollAnimation {
  constructor(props) {
    ScrollAnimation.__singletonRef = this;
    const { delay, duration } = props;
    this.setUp = false;
    this.delay = delay || 0.115;
    this.durationPerAnimation = duration || 0.125;
    this.lastScrollY = window.scrollY;
    this.lookForByClassName = ['scrollAnimate'];
    this.animations = ANIMATIONS;
    this.elements2Animate = [];
  }

  getElements2Animate = () => {
    const all = [];
    this.lookForByClassName.forEach(className => {
      all.push(...document.getElementsByClassName(className));
    });
    this.elements2Animate = all.filter(el => !el.style.getPropertyValue('animation-duration'));
  }

  isVisible = el => {
    const r = el.getBoundingClientRect();
    return r.top < window.innerHeight && r.bottom > 0;
  }

  getAnimation = classList => {
    const custom = classList.find(c => c.startsWith('scrollAnimate:'));
    if (custom) return custom.split(':')[1];
    const idx = Math.floor(Math.random() * this.animations.length);
    return this.animations[idx];
  }

  animateElements = rangeCheck => {
    const toRemove = [];
    let delaySum = this.delay;
    this.elements2Animate.forEach((el, i) => {
      if (rangeCheck(el)) {
        const anim = this.getAnimation([...el.classList]);
        el.classList.add(anim);
        const css = `animation-duration:${this.durationPerAnimation}s;-webkit-animation-duration:${this.durationPerAnimation}s;animation-delay:${delaySum}s;-webkit-animation-delay:${delaySum}s;`;
        el.style.cssText += css;
        delaySum += this.delay;
        toRemove.push(el);
      }
    });
    this.elements2Animate = this.elements2Animate.filter(el => !toRemove.includes(el));
  }

  // Para animar inmediatamente los visibles al init/back
  animateVisible = () => {
    this.animateElements(el => this.isVisible(el));
  }

  setAnimations = () => {
    const prevY = this.lastScrollY;
    const currY = window.scrollY;
    if (currY !== prevY) {
      const down = currY > prevY;
      const h = window.innerHeight;
      this.animateElements(el => {
        const r = el.getBoundingClientRect();
        const topDoc = r.top + currY;
        const bottomDoc = r.bottom + currY;
        if (down) {
          return topDoc < currY + h && bottomDoc > prevY;
        } else {
          return bottomDoc > currY && topDoc < prevY + h;
        }
      });
      this.lastScrollY = currY;
    }
    if (this.elements2Animate.length === 0) {
      window.removeEventListener('scroll', this.setAnimations);
    }
  }

  init = () => {
    if (this.setUp) return;
    this.getElements2Animate();
    // animar inmediatamente lo que ya está visible en la posición actual
    this.animateVisible();
    this.lastScrollY = window.scrollY;
    window.addEventListener('scroll', this.setAnimations);
    this.setUp = true;
  }

  destroy = () => {
    window.removeEventListener('scroll', this.setAnimations);
    this.setUp = false;
  }

  static init() {
    ScrollAnimation.__singletonRef.init();
  }

  static refreshElements2Animate() {
    ScrollAnimation.__singletonRef.destroy();
    ScrollAnimation.__singletonRef.init();
  }
}

export default ScrollAnimation;
